import { RecoilState, atom, selector } from "recoil";
import { AdvisorsLinkedToClientsResult } from "../../Component/Model/Dto/Advisory/Employee";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const ClientAdvisorAtom: RecoilState<AdvisorsLinkedToClientsResult[] | null> = atom <AdvisorsLinkedToClientsResult[] | null> ({
    key: 'ClientAdvisorAtom',
    default: null,
    effects_UNSTABLE : [persistAtom]
});

export const ClientAdvisorSelector = selector<AdvisorsLinkedToClientsResult[] | null>({
    key: 'ClientAdvisorSelector',
    get: ({ get }) => {
      const clientAdvisorState = get(ClientAdvisorAtom);
      return clientAdvisorState;
    },
  });